import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AreaChart: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M3 3v18h18' }],
    ['path', { d: 'M7 12v5h12V8l-5 5-4-4Z' }],
  ],
];

export default AreaChart;
